const appInformation = {
    production: false,
    name: 'dev',
    version: '1.0.0',
    region: 'us-gov-west-1',
    url: 'localhost:4200',
    endpoint: 'https://template-cognito-sample-dev.pavcongems.com',
    sandboxEnabled: false,
  };

  const redirects = {
    uam: 'http://localhost:4200/auth/login',
    warfigther: 'https://warfighter-dev.cristlgov.com/',
    safire: 'https://safire-dev.cristlgov.com'
  }


  
  const amplifyInformation = {
    Auth: {
      region: 'us-gov-west-1',
      userPoolId: 'us-gov-west-1_9K6bFGREl',
      userPoolWebClientId: '3kqk01a128lk0ts5068dn7jdbt',
      Cognito: {
        userPoolClientId: '3kqk01a128lk0ts5068dn7jdbt',
        userPoolId: 'us-gov-west-1_9K6bFGREl',
      },
  
      cookieStorage: {
        domain: '.pavcongems.com',
        path: '/',
        expires: 365,
        sameSite: 'strict',
      },
    },
  };

  const cookieInfo = {
    cookieStorage: {
        domain: '.pavcongems.com',
        path: '/',
        expires: 365,
        sameSite: 'strict',
    }
  }
  
  export const environment = {
    ...appInformation,
    redirects,
    cookieInfo,
    amplify: amplifyInformation,
  };
  